import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { ActionCreators } from '../../actions';

class Setting extends Component {
    render() {
        return (
            <div>
                Setting
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Setting));


// WEBPACK FOOTER //
// ./src/pages/auth/setting.js